var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 20",
    style: {
      enableBackground: "new 0 0 24 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,19.6l-7.6-5.8c-2.8-2.1-4.1-5.7-3.3-9.2C1.8,2.1,4,0.4,6.6,0.4H7c1.5,0,3,0.6,4.1,1.6L12,2.8L12.9,2 c1.1-1,2.6-1.6,4.1-1.6h0.4c2.6,0,4.8,1.8,5.4,4.3c0.8,3.4-0.5,7-3.3,9.2L12,19.6z M6.6,2.4c-1.7,0-3.1,1.1-3.5,2.7 c-0.6,2.7,0.4,5.4,2.5,7.1l6.4,4.9l6.4-4.9c2.2-1.7,3.2-4.5,2.5-7.1c-0.4-1.6-1.8-2.7-3.4-2.7H17c-1,0-2,0.4-2.8,1.1L12,5.6 L9.7,3.5C9,2.8,8,2.4,7,2.4H6.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.92acab7f1741750cfffc76d344206172.svg";
export { ForwardRef as ReactComponent };